import { render, staticRenderFns } from "./Refectory.vue?vue&type=template&id=7b5090e3&scoped=true"
import script from "./Refectory.vue?vue&type=script&lang=js"
export * from "./Refectory.vue?vue&type=script&lang=js"
import style0 from "./Refectory.vue?vue&type=style&index=0&id=7b5090e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5090e3",
  null
  
)

export default component.exports